const generateComponentTheme = ({spacing}) => {
  return {
    returnButtonContainerRightMargin: spacing.small,
  }
}

export default generateComponentTheme
